// root/varta-frontend/src/components/TopNav.jsx

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import NotificationBell from "./NotificationBell";
import "../theme/design.css";

export default function TopNav() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
const menuRef = useRef(null);

const logout = () => {
  localStorage.clear();
  window.location.href = "/login";
};

const location = useLocation();
const showSearchBar = location.pathname === "/search";

const user = JSON.parse(localStorage.getItem("user") || "null");
const token = localStorage.getItem("token");

useEffect(() => {
  const handler = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", handler);
  return () => document.removeEventListener("mousedown", handler);
}, []);

  return (
  <div   className="topnav"   style={{     position: "relative",     zIndex: 2001,     width: "100%",   }} >

    <div
      style={{
        maxWidth: 720,
        margin: "0 auto",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        gap: 10
      }}
    >
      {/* Logo */}
<div
  onClick={() => navigate("/")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    fontWeight: 800,
    fontSize: 18
  }}
>
  <img
    src="/icon-512.png"
    alt="Varta"
    style={{
      width: 26,
      height: 26,
      borderRadius: 6
    }}
  />
  <span>VARTA</span>
</div>

      {/* Search */}

{showSearchBar ? (

<input
  placeholder="Search users"
  autoFocus
  onKeyDown={(e)=>{
    if(e.key==="Enter"){
      navigate(`/search?q=${encodeURIComponent(e.target.value)}`)
    }
  }}
  style={{
  flex: 1,
  minWidth: 0,
  background: "#0b1220",
  border: "1px solid #1b2532",
  borderRadius: 999,
  padding: "6px 12px",
  color: "#e5e7eb",
  fontSize: 16,
  boxSizing: "border-box",
}}
/>

) : (

<button
  className="btn btn-ghost"
  onClick={()=>navigate("/search")}
  style={{fontSize:18}}
>
🔍
</button>

)}

      {/* Notifications */}
      <NotificationBell token={token} />
      {/* Desktop Menu */}
<div ref={menuRef} style={{ position: "relative" }}>
  <button
    className="btn btn-ghost"
    onClick={() => setMenuOpen(!menuOpen)}
    style={{ fontSize: 20 }}
  >
    ☰
  </button>

  {menuOpen && (
    <div
      style={{
        position: "absolute",
        right: 0,
        top: 36,
        background: "#111827",
        borderRadius: 8,
        padding: 10,
        width: 200,
        boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>

<Link to="/conversations" onClick={() => setMenuOpen(false)}>
  Messages
</Link>

<Link to={`/u/${user?.user_id}`} onClick={() => setMenuOpen(false)}>
  Profile
</Link>

<Link to="/edit-profile" onClick={() => setMenuOpen(false)}>
  Edit profile
</Link>

      <button
        onClick={logout}
        style={{
          background: "none",
          border: "none",
          color: "#fff",
          textAlign: "left",
          cursor: "pointer",
        }}
      >
        Logout
      </button>
    </div>
  )}
</div>
    </div>
</div>
  );
}